
import React from 'react';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
import { generateExcelTemplate } from '@/utils/cycle-tracking/import';

interface TemplateDownloadStepProps {
  isDisabled: boolean;
}

const TemplateDownloadStep: React.FC<TemplateDownloadStepProps> = ({ isDisabled }) => {
  const handleDownloadTemplate = () => {
    const templateBlob = generateExcelTemplate();
    const url = URL.createObjectURL(templateBlob);
    
    const a = document.createElement('a');
    a.href = url;
    a.download = 'cycle_data_template.xlsx';
    document.body.appendChild(a);
    a.click();
    
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 100);
  };

  return (
    <div className="mb-6">
      <h2 className="text-lg font-medium mb-2">Step 1: Download Template</h2>
      <p className="text-muted-foreground mb-4">
        Download our Excel template to format your cycle data correctly.
      </p>
      <Button 
        variant="outline" 
        onClick={handleDownloadTemplate}
        disabled={isDisabled}
      >
        <Download className="mr-2 h-4 w-4" />
        Download Template
      </Button>
    </div>
  );
};

export default TemplateDownloadStep;
